import PropTypes from 'prop-types';
import styles from './AuxiliaryIndicator.module.css';

const AuxiliaryIndicator = ({ show = false, className = '' }) => {
    if (!show) return null;

    return <span className={`${styles['auxiliary-indicator']}${className ? ` ${className}` : ''}`}>Auxiliary</span>;
};

AuxiliaryIndicator.propTypes = {
    show: PropTypes.bool,
    className: PropTypes.string,
};

export default AuxiliaryIndicator;
